jQuery(document).ready(function ($) {
  var mafs = $('#my-ajax-filter-search');
  var mafsForm = mafs.find('form');
  var mafsResult = mafs.parent().next();

  console.log('clicked');

  // $('#my-ajax-filter-search input[type=radio]').on('change', function () {
  //   //$(this).closest('form').submit();

  //   console.log('form submitted');
  // });

  //mafsForm.submit(function (e) {
  // $('.gfield-choice-input').click(function () {
  //e.preventDefault();

  //console.log('form submitted');

  $('#my-ajax-filter-search input[type=radio]').on('change', function () {
    var eventdate = mafsForm.find('input[type="radio"]:checked').val();
    var categoryid = mafsForm.data('cat');

    var data = {
      action: 'my_ajax_filter_search',
      //search: search,
      eventdate: eventdate,
      categoryid: categoryid,
    };

    $.ajax({
      url: ajax_info.ajax_url,
      data: data,
      beforeSend: function () {
        $('.filter-loader').show();
      },
      complete: function () {
        $('.filter-loader').hide();
      },
      success: function (response) {
        //console.log(mafsResult);
        mafsResult.empty();

        if (response) {
          for (var i = 0; i < response.length; i++) {
            if (response[i].featimage) {
              $image = response[i].featimage;
            } else {
              $image =
                '/wp-content/themes/mrcc/dist/images/post-placeholder.jpg';
            }
            var html =
              "<div class='c-post__item bg-custom_white  mb-16 relative shadow-md' id='post-" +
              response[i].id +
              "'>";
            html +=
              "  <a class='block u-a-nostyle' href='" +
              response[i].permalink +
              "' title='" +
              response[i].title +
              "'>";

            html += "<div class='c-post__image'>";

            html +=
              "<div style='background-image:url(" +
              $image +
              ");' class='w-full h-56 xl:h-72 relative overflow-hidden bg-top bg-no-repeat bg-cover'></div>";
            html += '</div>';
            html += '</a>';
            html += "<div class='px-5 py-3 relative z-10 xl:pt-4 md:pb-5'>";
            html += '<div class="mt-2 mb-2">' + response[i].cats + '</div>';
            //html += '<span>' + response[i].starttime + '</span></br>';
            //html += '<span>' + response[i].today + '</span>';
            //html += '<span>' + response[i].categoryid + '</span>';
            html +=
              "  <a class='block u-a-nostyle pt-1 md:pt-0 lg:pb-6 no-underline' href='" +
              response[i].permalink +
              "' title='" +
              response[i].title +
              "'>";
            html +=
              "<h4 class='para-text font-body normal-case'>" +
              response[i].title +
              '</h4>';
            html += '</a>';
            html += '</div>';
            html += '</div>';
            mafsResult.append(html);
          }
        } else {
          var html =
            "<li class='no-result'>Sorry there are no events to show for this category.</li>";
          mafsResult.append(html);
        }
      },
      error: function () {
        mafsResult.empty();
        var html =
          '<h3>Sorry there are no events to show for this category.</h3>';
        mafsResult.append(html);
      },
    });
  });
});
